import React from 'react';

var MobileHeaderLogo = function (_a) {
    var src = _a.src, _b = _a.alt, alt = _b === void 0 ? '' : _b;
    return (React.createElement("img", { src: src, alt: alt }));
};

export { MobileHeaderLogo };
